export default __webpack_public_path__ + "static/Cashflow 101+202-7-3064786a338b597cdeec3bcbdcafb0a7.jpg";